import React from "react";
import CenterContainer from "../components/CenterContainer";
import Footer from "../components/Footer";
import Title from "../components/Title";

export function GDPR() {
    return (
        <>
            <CenterContainer style={{ margin: "2em 0" }}>
                <Title>GDPR-Informatiedocument Consumerhouse</Title>

                <h2>1. Inleiding</h2>
                <p>
                    Consumerhouse hecht veel belang aan de bescherming van uw persoonsgegevens. In overeenstemming met de Algemene Verordening
                    Gegevensbescherming (EU 2016/679, hierna 'GDPR'), willen wij u informeren over hoe wij uw gegevens verwerken en welke rechten u
                    heeft.
                </p>

                <h2>2. Verwerkingsverantwoordelijke</h2>
                <p>De verwerkingsverantwoordelijke voor uw persoonsgegevens is:</p>
                <p>
                    <strong>ConsumerHouse</strong>
                    <br />
                    Adres: Ternesselei 324 - 2160 Wommelgem
                    <br />
                    E-mail: <a href="mailto:contact@consumerhouse.be">contact@consumerhouse.be</a>
                </p>

                <h2>3. Welke gegevens verwerken wij?</h2>
                <p>Wij verzamelen en verwerken de volgende categorieën persoonsgegevens:</p>
                <ul>
                    <li>Identificatiegegevens (naam, voornaam, geboortedatum)</li>
                    <li>Contactgegevens (adres, telefoonnummer, e-mailadres)</li>
                    <li>Gegevens met betrekking tot deelname aan marktonderzoeken</li>
                    <li>Voorkeuren en feedback met betrekking tot producten en diensten</li>
                </ul>

                <h2>4. Doeleinden en rechtsgrond van de verwerking</h2>
                <p>Uw persoonsgegevens worden verwerkt voor de volgende doeleinden:</p>
                <ul>
                    <li>Deelname aan marktonderzoek, waaronder producttesten en voedingswarenproeven</li>
                    <li>Communicatie over lopende en toekomstige onderzoeken</li>
                    <li>Statistische en analytische doeleinden</li>
                    <li>Voldoen aan wettelijke verplichtingen</li>
                </ul>
                <p>De verwerking gebeurt op basis van uw toestemming en ons gerechtvaardigd belang in het uitvoeren van marktonderzoek.</p>

                <h2>5. Bewaartermijn</h2>
                <p>
                    Uw gegevens worden niet langer bewaard dan noodzakelijk voor de hierboven vermelde doeleinden en in overeenstemming met de
                    wettelijke bewaartermijnen.
                </p>

                <h2>6. Beveiliging van uw gegevens</h2>
                <p>
                    Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen ongeautoriseerde toegang,
                    verlies of misbruik.
                </p>

                <h2>7. Delen van gegevens met derden</h2>
                <p>
                    Door deel te nemen aan ons marktonderzoek gaat u ermee akkoord dat wij de noodzakelijke informatie delen met onze partners,
                    uitsluitend voor de uitvoering van het onderzoek. Wij garanderen dat uw gegevens na voltooiing van de opdracht worden verwijderd
                    en niet verder worden verspreid of gebruikt voor andere doeleinden.
                </p>

                <h2>8. Uw rechten</h2>
                <p>U heeft de volgende rechten met betrekking tot uw persoonsgegevens:</p>
                <ul>
                    <li>
                        <strong>Recht op inzage:</strong> U kunt een kopie van uw gegevens opvragen
                    </li>
                    <li>
                        <strong>Recht op rectificatie:</strong> U kunt onjuiste of onvolledige gegevens laten corrigeren
                    </li>
                    <li>
                        <strong>Recht op verwijdering:</strong> U kunt verzoeken om uw gegevens te laten verwijderen
                    </li>
                    <li>
                        <strong>Recht op beperking van de verwerking:</strong> U kunt onder bepaalde voorwaarden de verwerking laten beperken
                    </li>
                    <li>
                        <strong>Recht op bezwaar:</strong> U kunt bezwaar maken tegen de verwerking van uw gegevens
                    </li>
                    <li>
                        <strong>Recht op gegevensoverdraagbaarheid:</strong> U kunt vragen om uw gegevens over te dragen naar een andere partij
                    </li>
                </ul>
                <p>U kunt uw rechten uitoefenen door contact met ons op te nemen via bovengenoemde contactgegevens.</p>

                <h2>9. Klachten</h2>
                <p>
                    Indien u klachten heeft over de verwerking van uw persoonsgegevens, kunt u contact opnemen met ons of een klacht indienen bij de
                    Gegevensbeschermingsautoriteit:
                </p>
                <p>
                    <strong>Gegevensbeschermingsautoriteit</strong>
                    <br />
                    Adres: Drukpersstraat 35, 1000 Brussel
                    <br />
                    Website:{" "}
                    <a href="https://www.gegevensbeschermingsautoriteit.be/" target="_blank">
                        https://www.gegevensbeschermingsautoriteit.be/
                    </a>
                </p>

                <h2>10. Akkoordverklaring</h2>
                <p>
                    Door deel te nemen aan ons marktonderzoek, verklaart u zich akkoord met de inhoud van dit GDPR-Informatiedocument en onze
                    richtlijnen met betrekking tot gegevensbescherming.
                </p>

                <h2>11. Wijzigingen in dit document</h2>
                <p>Dit document kan periodiek worden aangepast. De meest recente versie is steeds beschikbaar via onze website.</p>
            </CenterContainer>
            <Footer />
        </>
    );
}
